import { Fragment, useEffect, useState } from 'react'
import { IsDeveloper } from '~/components/Auth'
import { Box } from '~/shared/ui'
import { showInZone, useZone } from '~/team_tools/components/timezone'
import { TeamUser } from '../api'
import { jsonrpc } from '~/shared/api/jsonrpc'

// Mounted only inside the role check: the fetch used to run before it, so a
// login without the role still pulled every staff email into the browser.
const Members = () => {
    const [members, setMembers] = useState<Array<TeamUser>>([])
    const [zone] = useZone()

    useEffect(() => {
        jsonrpc('accounts.staff').then((resp) => setMembers(resp.result ?? []))
    }, [])

    return (
        <Box>
            <header className='uppercase font-bold text-center py-2 text-2xl'>Team Members</header>
            <Box className='border border-white/10 rounded-lg overflow-hidden py-8'>
                <div className=' bg-custom-gradient-1 h-1 absolute top-0 left-0 w-full'></div>

                <div className='grid grid-cols-[repeat(9,max-content)] gap-4 p-4 items-center w-full lg:justify-center  overflow-auto'>
                    <div className='opacity-50 font-light'>User</div>
                    <div className='opacity-50 font-light'>Email</div>
                    <div className='opacity-50 font-light' title='Last sign-in on the website. Game logins do not set it.'>
                        Last website login
                    </div>
                    {/* is_staff gets its own column: for some members it is the
                        only flag they hold, and three unlit dots read as "no
                        role at all". */}
                    <div className='opacity-50 font-light'>Staff</div>
                    <div className='opacity-50 font-light'>Developer</div>
                    <div className='opacity-50 font-light'>Marketing</div>
                    <div className='opacity-50 font-light'>Executive</div>
                    {/* Active accounts only, and everyone who can get in: a
                        superuser with no flag and a capability grant are
                        access too, and this list is where access is reviewed
                        (decision D-080). */}
                    <div className='opacity-50 font-light'>Superuser</div>
                    <div className='opacity-50 font-light'>Grants</div>
                    {members.map(
                        ({ username, email, last_login, is_staff, is_developer, is_marketing, is_executive, is_superuser, capabilities }, i) => (
                            <Fragment key={i}>
                                <div className=''>{username}</div>
                                <div>{email}</div>
                                <div className='text-xs'>{last_login ? showInZone(last_login, zone) : 'never'}</div>
                                {[is_staff, is_developer, is_marketing, is_executive, is_superuser].map((value, i) => (
                                    <div key={i} className='flex flex-row items-center'>
                                        <div
                                            className={`h-3 w-3 mx-auto rounded-full bg-white ${
                                                value ? '' : 'opacity-10'
                                            }`}
                                        >
                                            &nbsp;
                                        </div>
                                    </div>
                                ))}
                                <div className='text-xs'>{capabilities?.length ? capabilities.join(', ') : '—'}</div>
                            </Fragment>
                        )
                    )}
                </div>
            </Box>
        </Box>
    )
}

export const TeamMembers = () => (
    <IsDeveloper>
        <Members />
    </IsDeveloper>
)
